/* Blackout v2.0.0
 * Implements a global blackout utility object.
 */

import * as $ from "jquery";

import GEModal from "./GEModal";

export default class Blackout {
	static using: Array<GEModal> = [];
	static element: JQuery;

	/**
	 * Initializes the blackout with the given element.
	 */
	static initialize(element: JQuery) {
		Blackout.element = element;

		element.click(Blackout.close);
	}

	/**
	 * Closes the blackout and all elements using it.
	 */
	static close() {
		if (Blackout.using.length > 0) {
			let using = Blackout.using;
			Blackout.using = [];

			using.forEach(function(element: GEModal) {
				element.hide();
			});
		}

		Blackout.element.removeClass("active");
	}

	/**
	 * Returns whether the given element is using the modal.
	 * @param element The element to check.
	 */
	static isUsing(element: GEModal): number|boolean {
		let index = Blackout.using.indexOf(element);

		if (index < 0) {
			return false;
		}

		return index;
	}

	/**
	 * Notifies the blackout that this element is using it.
	 * @param element The element using the blackout.
	 */
	static use(element: GEModal) {
		if (!Blackout.isUsing(element)) {
			Blackout.using.push(element);
		}

		Blackout.element.addClass("active");
	}

	/**
	 * Notifies the blackout that this element is no longer using it.
	 * @param element The element not longer using the blackout.
	 */
	static unuse(element: GEModal) {
		let index = Blackout.isUsing(element);

		if (index > -1) {
			Blackout.using.splice(<number>index, 1);
		}

		if (Blackout.using.length == 0) {
			Blackout.close();
		}
	}
}